import { render } from "./CategorySetting.vue?vue&type=template&id=36820625&scoped=true"
import script from "@/assets/js/category.js?vue&type=script&lang=js&external"
export * from "@/assets/js/category.js?vue&type=script&lang=js&external"

import "@/assets/css/category.css?vue&type=style&index=0&id=36820625&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36820625"]])

export default __exports__